import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpHeaderTopBarComponent from './adpHeaderTopBar.component';

let adpHeaderTopBarModule = angular.module('adpHeaderTopBar', [
  uiRouter
])

.component('adpHeaderTopBar', adpHeaderTopBarComponent)

.name;

export default adpHeaderTopBarModule;



// WEBPACK FOOTER //
// ./src/app/components/adpHeaderTopBar/adpHeaderTopBar.js